module.exports = __webpack_public_path__ + "static/media/actions-bold.84fd9baf.svg";